import toast from 'react-hot-toast';
import { registerSW } from 'virtual:pwa-register';

export function registerPwa(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  // В dev тоже регистрируем (LAN / телефон), иначе PWA не поставить с :5177
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      toast(
        (t) => (
          <span className="flex items-center gap-3">
            <span>Доступно обновление</span>
            <button
              type="button"
              onClick={() => {
                toast.dismiss(t.id);
                void updateSW(true);
              }}
              className="font-semibold text-orange hover:opacity-80"
            >
              Обновить
            </button>
          </span>
        ),
        { duration: 10_000, position: 'bottom-center' },
      );
    },
  });
}
